import React, { useContext } from 'react';
import './AvailablePerks.scss';
import { PageSectionPB } from '../../PricingBenefits/shared';
import { HasPerksSummary, HasNoPerksBanner } from './components';
import { HasPerksModal } from './components/HasPerksModal';
import { InfoPerksContext, PerkProgressContext } from '../../../contexts';
export var AvailablePerks = function (props) {
    var isMobile = props.isMobile;
    return (React.createElement("div", { className: "AvailablePerks__MobileContainer" },
        React.createElement(PageSectionPB, { title: "Available Perks" },
            React.createElement(AvailablePerksPageAndModal, { isMobile: isMobile }))));
};
var AvailablePerksPageAndModal = function (_a) {
    var isMobile = _a.isMobile;
    var perksList = useContext(InfoPerksContext).perksList;
    var activatedPerks = useContext(PerkProgressContext).activatedPerks;
    var statePack = {
        modalState: React.useState(false),
        detailState: React.useState({}),
    };
    return !(perksList === null || perksList === void 0 ? void 0 : perksList.length) && !activatedPerks.length ? (React.createElement(HasNoPerksBanner, { isMobile: isMobile })) : (React.createElement(React.Fragment, null,
        React.createElement(HasPerksModal, { isMobile: isMobile, statePack: statePack }),
        React.createElement(HasPerksSummary, { isMobile: isMobile, statePack: statePack })));
};
